export const environment = {
  production: true,
  rapi: 'https://api.ltsnhelp.com',
  multisite: {
    name: 'pussnboots-deposit-freespin',
    view: '.simple-casino',
    apiresources: 'https://d3tmfelegj51yl.cloudfront.net/landings/casino/pussnboots-deposit-freespin/i18n/',
    defaultLang: { lenid: 'en', lennombre: 'English' },
    langs: [
      { lenid: 'en', lennombre: 'English' },
      { lenid: 'es', lennombre: 'Español' },
      { lenid: 'pt', lennombre: 'Portugues' }
    ]
  },
  sentry: {
    dsn: 'https://8122d2bf17a14a61b01885af3a9f4e90@sentry.io/5029794',
    reportDialog: false,
    enable: false,
    logs: false
  },
  environment: 'pussnboots-deposit-freespin.production',
  version: '1.0',
  lottery: {
    lot_id: 0,
    synd_prc_code: {
      wt: 0,
      ltk: 0
    },
    offer: {
      base: 0,
      multiplier: 0,
      picks: {
        count: 0,
        from: 0,
        to: 0
      },
      extra_picks: {
        count: 0,
        from: 0,
        to: 0
      }
    }
  },
  pcode: {
    wt: 'PUSSN10U30SWT',
    ltk: 'PUSSN10U30SLTK'
  },
  type: 'casino-deposit',
  product_type: null,
  product_id: null,
  pick_type: null,
  source: 'pussnboots-deposit-freespin',
  domainRestriction: null,
  upsellPage: null,
  promoSyndicate: false,
  templateIdPromoWT: 150,
  templateIdPromoLTK: 151,
  AES_CODE: '0PC0s9#MrgPHaJHi'
};
